[
 {
  "id": "back",
  "x": 20,
  "y": 20,
  "w": 102,
  "h": 100
 },
 {
  "id": "sound",
  "x": 818,
  "y": 20,
  "w": 106,
  "h": 102
 },
 {
  "id": "logo",
  "x": 236,
  "y": 22,
  "w": 488,
  "h": 334
 },
 {
  "id": "doodle.left",
  "x": 26,
  "y": 146,
  "w": 154,
  "h": 214
 },
 {
  "id": "doodle.right",
  "x": 776,
  "y": 126,
  "w": 138,
  "h": 210
 },
 {
  "id": "title",
  "x": 120,
  "y": 830,
  "w": 746,
  "h": 212
 },
 {
  "id": "sendcode",
  "x": 176,
  "y": 1258,
  "w": 594,
  "h": 128
 },
 {
  "id": "field",
  "x": 106,
  "y": 1128,
  "w": 730,
  "h": 122
 }
]